/*
 * 本地接口，依赖业务自身url
 */
import { Request } from "@cttq/cttq-request";
// require.js中


export function getCipherText(url: String, data:any, baseURL = "", headers={}) {
	console.log("🚀 ~ getCipherText ~ baseURL:", baseURL, headers)
	let serverInstance = new Request({
		headers: {
			"Content-Type": "application/json",
			reqSource: "pc",
		},
    	baseURL
	})
	return serverInstance["post"]({
		url: url,
		headers: headers,
		data,
	})
}
